import React, { useState } from 'react';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';

import { useTranslation } from 'react-i18next';
import { Theme } from '@mui/material/styles';
import { Clear } from '@mui/icons-material';
import { Search as SearchIcon} from '@mui/icons-material';
import { Paper, IconButton, InputBase} from '@mui/material';
const  IsPC = () => {
  const userAgentInfo = navigator.userAgent; 
  const Agents = ['Android', 'iPhone',
    'SymbianOS', 'Windows Phone',
    'iPad', 'iPod'];
  let flag = true;
  for (let v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft:IsPC()?'40px':'0px',
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: IsPC()?'400px':'100%',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      height: 28,
      margin: 4,
    },
  }),
);

export default function CustomizedInputBase(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const {setSearchText, searchText ,diyClasses=classes,defaultTitle=t('share.form.searchFileName')} = props;
 
  const [value, setValue] = useState(searchText);

  return (
    <Paper className={diyClasses.root}>
      <IconButton className={diyClasses.iconButton} aria-label="menu">
        <SearchIcon />
      </IconButton>
      <InputBase
        value={value}
        type='text'
        onChange={(e) => {
          setValue(e.target.value);
        }}
        onKeyDown={(e) => {
          if (e.keyCode==13) {
            setSearchText(e.target.value);
          }
        }}
        onBlur={(e) => {
          setSearchText(e.target.value);
        }}
        className={diyClasses.input}
        placeholder={defaultTitle}
        inputProps={{ 'aria-label': '' }}
      />
      <IconButton onClick={(e) => {
        setValue('');
        setSearchText('');
      }} type="submit" className={diyClasses.iconButton} aria-label="search">
        <Clear/>
      </IconButton>
    </Paper>
  );
}
